import { render, staticRenderFns } from "./ProductInsights.vue?vue&type=template&id=541cb98b&scoped=true&"
import script from "./ProductInsights.vue?vue&type=script&lang=js&"
export * from "./ProductInsights.vue?vue&type=script&lang=js&"
import style0 from "./ProductInsights.vue?vue&type=style&index=0&id=541cb98b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541cb98b",
  null
  
)

export default component.exports